<template>
  <span class="eb-status" :class="getClassName()">
    <span class="eb-status__dot"></span>
    <span class="eb-status__text">{{ getText() }}</span>
  </span>
</template>

<script setup>
const props = defineProps(['status'])
const $str = window.$str

function getClassName() {
  const statusMap = {
    '0': 'enable',
    '1': 'disabled'
  }
  return statusMap[props.status] || ''
}

function getText() {
  const textMap = {
    '0': $str.getKey('参数设置/运行中'),
    '1': $str.getKey('参数设置/已停用')
  }
  return textMap[props.status] || '--'
}
</script>

<style lang='scss' scoped>
.eb-status {
  display: inline-flex;
  align-items: center;
  margin-right: 10px;

  &__dot {
    width: 8px;
    height: 8px;
    background: #c2cae2;
    border-radius: 50%;
    margin-right: 6px;
  }

  &__text {
    font-size: 12px;
    color: #96a5b8;
  }

  &.enable {
    .eb-status__dot {
      background-color: var(--color-success, #36c070);
      box-shadow: 0 0 6px rgba(54, 192, 112, 0.5);
    }

    .eb-status__text {
      color: var(--color-success, #36c070);
    }
  }

  &.disabled {
    .eb-status__dot {
      background-color: #ff4d4f;
    }

    .eb-status__text {
      color: #ff4d4f;
    }
  }
}
</style>
